import { render, staticRenderFns } from "./AvisoCargasQuebradas.vue?vue&type=template&id=03376cb8&scoped=true"
import script from "./AvisoCargasQuebradas.vue?vue&type=script&lang=js"
export * from "./AvisoCargasQuebradas.vue?vue&type=script&lang=js"
import style0 from "./AvisoCargasQuebradas.vue?vue&type=style&index=0&id=03376cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03376cb8",
  null
  
)

export default component.exports